import { instance } from "../axios/axiosConfig";
import {
  CommunityAggregateDataTypes,
  CommunityBodyTypes,
} from "../types/discoverCommunitiesTypes.tsx";

const discoverCommunitiesApi = {
  fetchPersonaCommunitiesData(data: CommunityBodyTypes) {
    return instance.get(`/api/personas/${data.id}/communities/`, {
      params: data.params,
    });
  },
  fetchPersonaCommunitiesAggregateData(data: CommunityAggregateDataTypes) {
    return instance.post(
      `/api/personas/${data.id}/communities/aggregate/`,
      data.body,
    );
  },
};

export default discoverCommunitiesApi;
